import { createApp } from 'vue';
import App from './App.vue';
import { router } from './router';
import './components'
import 'vant/es/toast/style'
import 'vant/es/dialog/style'
import './styles/index.less'
import { Toast } from 'vant';

// const a = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dpblR5cGUiOiJsb2dpbiIsImxvZ2luSWQiOiJzeXNfdXNlcjoxIiwicm5TdHIiOiJUQWpNeDFyd1BvUGliWFNEQ0dUbEtYdGdNMmg4Q3NUSSJ9.4PtGlfVu_BBBoX9E57-cP7tgmcTiRDO4urgEZk3CqUQ'
const app = createApp(App);
app.use(router);
app.mount('#app');
app.use(Toast);
// document.cookie = `Authorization=${a}; path=/;`
